<template>
  <v-autocomplete
    :items="items"
    v-model="val"
    :label="label"
    :item-text="item_text"
    :item-value="item_value"
    :disabled="items.length == 0 || !loaded"
  ></v-autocomplete>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import Vue from 'vue';
import EventExternalModel from '@/models/event_external.js'

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'label',
    'name',
    'content_id',
    'from',
    'from_key',
    'item_text',
    'item_value'
  ],
  data () {
    return {
      sports: [],
      series: [],
      loaded: false
    }
  },
  created () {
    this.load_data();
  },
  methods: {
    series_by_sport (sport) {
      var sport_id = (typeof(sport) == "object" ? sport.value : sport);
      return this.series.filter((serie) => {
        return serie.sport_id == sport_id;
      });
    },
    load_data () {
      var self = this;
      EventExternalModel.load_sports_and_series(function(sports, series) {
        self.sports = sports;
        self.series = series;
        self.loaded = true;
      });
    }
  },
  computed: {
    from_data () {
      if(!this.from) return undefined;
      return _.get(this.value, this.from);
    },
    items () {
      if(this.content_id == "sports") {
        return this.sports;
      } else if (this.content_id == "series" && typeof(this.from_data) != "undefined" && this.series.length > 0) {
        var list = this.series_by_sport(this.from_data);

        if(typeof(this.val) != "undefined" && typeof(list.find((item) => { return item[this.item_value] == this.val; })) == "undefined") {
          this.val = undefined;
        }
        return list;
      } else {
        return [];
      }
    },
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
